import {HostListener, Injectable} from '@angular/core';
import {AbstractControl, FormControl, UntypedFormGroup} from '@angular/forms';
import {VALIDATION_ERRORS_MESSAGE} from '../../constants/validation-errors.const';
import * as moment from 'moment-mini-ts';

@Injectable()
export class ValidationService {
  static getValidatorErrorMessage(
    validatorName: string,
    validatorValue?: any,
    label?: string
  ) {
    const config = {
      required: VALIDATION_ERRORS_MESSAGE.REQUIRED,
      maxlength:
        'В поле ' +
        '"' +
        label +
        '"' +
        ' ' +
        'может быть максимум' +
        ' ' +
        validatorValue.requiredLength +
        ' символов',
      minlength:
        'В поле ' +
        '"' +
        label +
        '"' +
        ' ' +
        'должно быть минимум' +
        ' ' +
        validatorValue.requiredLength +
        ' символов',
      language: VALIDATION_ERRORS_MESSAGE.LANGUAGE,
      languageplural: VALIDATION_ERRORS_MESSAGE.LANGUAGE_PLURAL,

      dob: VALIDATION_ERRORS_MESSAGE.BIRTHDAY_MIN,
      minyear: VALIDATION_ERRORS_MESSAGE.BIRTHDAY_MAX,
      notfullbirthdate: VALIDATION_ERRORS_MESSAGE.NOT_FULL_BIRTHDATE,
      notfullpasportdate: VALIDATION_ERRORS_MESSAGE.NOT_FULL_PASSPORT_DATE,
      notexisteddate: VALIDATION_ERRORS_MESSAGE.DATE_NOT_EXIST,
      phonelength: VALIDATION_ERRORS_MESSAGE.PHONE_LENGTH,
      additionalphonelength: VALIDATION_ERRORS_MESSAGE.ADDITIONAL_PHONE_LENGTH,
      nonexistentphone: VALIDATION_ERRORS_MESSAGE.NON_EXISTENT_PHONE,
      coincidenceofphones: VALIDATION_ERRORS_MESSAGE.COINCIDENCE_OF_NUMBERS,
      confirmationCodeNotMatch: VALIDATION_ERRORS_MESSAGE.WRONG_CODE,
      emailFormat: VALIDATION_ERRORS_MESSAGE.EMAIL_PATTERN,
      emailSpace: VALIDATION_ERRORS_MESSAGE.EMAIL_SPACE,
      requiredtrue: VALIDATION_ERRORS_MESSAGE.INFO_COMPLAINT_REQUIRED,
      forbiddenseries: VALIDATION_ERRORS_MESSAGE.ERROR_SERIES,
      lengthpassportseries:
      VALIDATION_ERRORS_MESSAGE.FULL_LENGTH_PASSPORT_SERIES,
      lengthpassportnumber:
      VALIDATION_ERRORS_MESSAGE.FULL_LENGTH_PASSPORT_NUMBER,
      notfuturedate: VALIDATION_ERRORS_MESSAGE.DATE_NOT_FUTURE,
      lengthsubdivision: VALIDATION_ERRORS_MESSAGE.PASSPORT_CODE_REQUIRED,
      secretPhraseFormat: VALIDATION_ERRORS_MESSAGE.SECRET_PHRASE,
      passwordFormat: VALIDATION_ERRORS_MESSAGE.PASSWORD_PATTERN,
      complicacy: VALIDATION_ERRORS_MESSAGE.PASSWORD_LENGTH,
      birthplaceFormat: VALIDATION_ERRORS_MESSAGE.PASSPORT_BP_PATTERN,
      checkPassportDate: VALIDATION_ERRORS_MESSAGE.PASSPORT_DATE_OVERDUE,
      checkPassportDate14: VALIDATION_ERRORS_MESSAGE.DATE_BEFORE_FOURTEEN,
      emptyadditionalphoneowner:
      VALIDATION_ERRORS_MESSAGE.EMPTY_ADDITIONAL_PHONE_OWNER,
      addressFormat: VALIDATION_ERRORS_MESSAGE.PASSPORT_ADRESS_PATTERN,
      checkSmsConfirmationCode:
      VALIDATION_ERRORS_MESSAGE.WRONG_CONFIRMATION_CODE,
      smsConfirmationLength:
      VALIDATION_ERRORS_MESSAGE.WRONG_CONFIRMATION_CODE_LENGTH,
      yandexrequired: VALIDATION_ERRORS_MESSAGE.YANDEX_REQUIRED,
      yandexwalleterror: VALIDATION_ERRORS_MESSAGE.YANDEX_WALLET_ERROR,
      lengthbic: VALIDATION_ERRORS_MESSAGE.BIC_LENGTH,
      lengthaccount: VALIDATION_ERRORS_MESSAGE.ACCOUNT_LENGTH,
      bicformat: VALIDATION_ERRORS_MESSAGE.BIC_FORMAT,
      settlementAccountformat:
      VALIDATION_ERRORS_MESSAGE.SETTLMENT_ACCOUNT_FORMAT,
      emailduplicate: VALIDATION_ERRORS_MESSAGE.EMAIL_DUPLICATE,
      addressDataIntegrity: VALIDATION_ERRORS_MESSAGE.STREET_HOME_REQUIRED,
      regionFormat: VALIDATION_ERRORS_MESSAGE.REGION_FORMAT,
      cityFormat: VALIDATION_ERRORS_MESSAGE.CITY_FORMAT,
      bankname: VALIDATION_ERRORS_MESSAGE.BANK_NAME,
      recoveryCodeLength: VALIDATION_ERRORS_MESSAGE.RECOVERY_CODE_LENGTH,
      recoveryCode: VALIDATION_ERRORS_MESSAGE.RECOVERY_CODE,
      invalidDate: VALIDATION_ERRORS_MESSAGE.INVALID_DATE,
      invalidAmount: VALIDATION_ERRORS_MESSAGE.INVALID_AMOUNT,
      birthplaceLength: VALIDATION_ERRORS_MESSAGE.BIRTHPLACE_LENGTH,
      birthplaceWordBan: VALIDATION_ERRORS_MESSAGE.BIRTHPLACE_WORD_BAN,
    };
    return config[validatorName];
  }

  static language(control: UntypedFormGroup) {
    const value = control.value;
    if (value && value.length > 0) {
      const r = /^[а-яА-ЯёЁ]+((\ |-)[а-яА-ЯёЁ]+)*$/g;
      const isValid = r.test(value);
      return isValid ? null : {language: true};
    }
  }

  static addressDataIntegrity(control: UntypedFormGroup): {
    [key: string]: any;
  } {
    if (control && control.value) {
      const arr = control.value.split(',');
      return arr.length > 1 ? null : {addressDataIntegrity: true};
    }
  }

  // static addressFormat(control: UntypedFormGroup): { [key: string]: any } {
  //   const value = control.value;
  //   if (value && value.length > 0) {
  //     const formGroup = control.parent.controls;
  //
  //     const fieldName =
  //       Object.keys(formGroup).find((name) => control === formGroup[name]) ||
  //       null;
  //
  //     let error;
  //     const r = /^[а-яА-ЯёЁ0-9]+[а-яА-ЯёЁ0-9\s\-—–\.,'"\(\)№N\\\/]*$/;
  //     const rCity = /[а-яА-ЯёЁ0-9]+[а-яА-ЯёЁ0-9\s\-—–\.,\(\)№N\\\/]*$/;
  //     let isValid;
  //     switch (fieldName) {
  //       case 'region':
  //         isValid = r.test(value);
  //         error = { regionFormat: true };
  //         break;
  //       case 'city':
  //         if (value.split(',').length > 1) {
  //           const region = value.split(',')[0];
  //           const city = value.split(',')[1];
  //           const isValidRegion = r.test(region);
  //           const isValidCity = rCity.test(city);
  //           isValid = isValidRegion && isValidCity;
  //         } else {
  //           isValid = r.test(value);
  //         }
  //         error = { cityFormat: true };
  //         break;
  //       default:
  //         isValid = r.test(value);
  //         error = { addressFormat: true };
  //     }
  //     return isValid ? null : error;
  //   }
  // }

  static addressExists(control: FormControl): { [key: string]: boolean } {

    const {value} = control

    if (typeof value === 'string') {
      if (value.length === 0) {
        return {required: true}
      }
    } else {
      if (value.value.length === 0) {
        return {required: true}
      }
    }

  }

  static regionDynamicValidator(conlrol: UntypedFormGroup) {
    return null;
  }

  static phonelength(control: UntypedFormGroup): { [key: string]: any } {
    if (control.value.length === 0) {
      return {required: true};
    } else if (control.value.length === 10) {
      return null;
    } else {
      return {phonelength: true};
    }
  }

  static additionalphonelength(control: UntypedFormGroup): {
    [key: string]: any;
  } {
    if (control.value.length === 0) {
      return null;
    } else if (control.value.length === 10) {
      return null;
    } else {
      return {additionalphonelength: true};
    }
  }

  static emptyadditionalphoneowner(control: UntypedFormGroup): {
    [key: string]: any;
  } {
    return {emptyadditionalphoneowner: false};
  }

  static nonexistentphone(control: UntypedFormGroup): { [key: string]: any } {
    if (control.value === '') {
      return null;
    }
    return control.value.charAt(0) === '9' ? null : {nonexistentphone: true};
  }

  static emailFormat(control: UntypedFormGroup): { [key: string]: any } {
    const value = control.value;
    const r =
      /^((?!^\.)[а-яёА-ЯЁa-zA-Z0-9_\.\-])+([^-_.])+\@(([а-яёА-ЯЁa-zA-Z0-9\-_\.])+\.)+([а-яёА-ЯЁa-zA-Z]){2,5}$/;
    const isValid = r.test(value) && value.length > 0;
    return isValid ? null : {emailFormat: true};
  }

  static emailSpace (control: UntypedFormGroup): { [key: string]: any } {
    const value = control.value;
    const space =  /^\S+$/
    const isValid = space.test(value);
    return isValid ? null : {emailSpace: true};
  }

  static coincidenceofphones(control: UntypedFormGroup) {
    const mainPhoneValue = control.parent.parent.controls[
      'mainPhone'
      ].value.replace(/[+()\-_ ]+/g, '');
    const additionalPhoneValue = control.value.replace(/[+()\-_ ]+/g, '');
    if (additionalPhoneValue.length === 10) {
      if (mainPhoneValue === additionalPhoneValue) {
        return {coincidenceofphones: true};
      } else {
        return null;
      }
    }
  }

  // проверка на заполненную дату
  static isFullDate(date: Date): boolean {
    const length = moment(date).format('DD.MM.YYYY').length;
    return length === 10
  }

  static dob(control: UntypedFormGroup): { [key: string]: any } {
    return moment().diff(control.value, 'years', true) >= 18 ? null : {dob: true};
  }

  static minyear(control: UntypedFormGroup): { [key: string]: any } {
    return moment(control.value).get('years') < 1917 ? {minyear: true} : null
  }

  static notfullbirthdate(control: UntypedFormGroup): { [key: string]: any } {
    return ValidationService.isFullDate(control.value) ? null : {notfullbirthdate: true};
  }

  static notfullpasportdate(control: UntypedFormGroup): { [key: string]: any } {
    return ValidationService.isFullDate(control.value) ? null : {notfullpasportdate: true};
  }

  static notexisteddate(control: UntypedFormGroup): { [key: string]: any } {
    return moment(control.value).isValid() ? null : {notexisteddate: true};
  }

  static notfuturedate(control: UntypedFormGroup): { [key: string]: any } {
    return moment(control.value).isAfter(moment()) ? {notfuturedate: true} : null;
  }

  static requiredtrue(control: UntypedFormGroup): { [key: string]: any } {
    return control.value ? null : {requiredtrue: true};
  }

  static forbiddenseries(control: UntypedFormGroup): { [key: string]: any } {
    const forbidden = ['00', '02', '06', '13', '16', '21', '31', '35'];
    const series = control.value.replace(/\D/g, '');
    let format;
    let result = true;
    if (series.length === 4) {
      format = series.substr(0, 2);
      forbidden.forEach((e) => {
        if (e === format) {
          result = false;
        }
      });
    }
    return result ? null : {forbiddenseries: true};
  }

  static lengthpassportseries(control: UntypedFormGroup): {
    [key: string]: any;
  } {
    const series = control.value.replace(/\D/g, '');
    return series.length < 4 && series.length > 0
      ? {lengthpassportseries: true}
      : null;
  }

  static lengthpassportnumber(control: UntypedFormGroup): {
    [key: string]: any;
  } {
    const number = control.value.replace(/\D/g, '');
    return number.length < 6 && number.length > 0
      ? {lengthpassportnumber: true}
      : null;
  }

  static lengthsubdivision(control: UntypedFormGroup): { [key: string]: any } {
    return control.value.replace(/_/g, '').length < 7
      ? {lengthsubdivision: true}
      : null;
  }

  static secretPhraseFormat(control: UntypedFormGroup): { [key: string]: any } {
    const value = control.value;
    const r = /^[а-яА-ЯёЁ]*$/;
    const isValid = r.test(value) && value.length > 0;
    return isValid ? null : {secretPhraseFormat: true};
  }

  static passwordFormat(control: UntypedFormGroup): { [key: string]: any } {
    const value = control.value;
    // const regex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@!%?&])[A-Za-z\\d$@!%?&]{8,}$");
    //
    // if (!value) {
    //   return null
    // }
    //
    // if (regex.test(value)) {
    //   return null
    // } else {
    //   return {'passwordFormat': true};
    // }

    const exception = /[а-яё\s]/i;
    if (value.length < 6 || value.length > 30) {
      return {complicacy: true};
    } else if (exception.test(value)) {
      return {passwordFormat: true};
    } else {
      return null;
    }
  }

  static birthplaceFormat(control: UntypedFormGroup): { [key: string]: any } {
    const value = control.value;
    const r = /^[а-яА-ЯёЁ0-9]+[а-яА-ЯёЁ0-9\s\-—–\.,\(\)№]*$/;
    const isValidDuplNumber = value.length === value.length-value.replace(/\d/gm,'').length;
    const isValid = r.test(value) && value.length > 0;
    return !isValid || isValidDuplNumber ? {birthplaceFormat: true} : null;
  }

  static birthplaceLength(control: UntypedFormGroup): { [key: string]: any } {
    return control.value.length >= 5 ? null : {birthplaceLength: true}
  }

  static birthplaceWordBan(control: UntypedFormGroup): { [key: string]: any } {
    const value = control.value
    const regexAvailability = /(?:\s+|^)(?:ул|улица|ул\.|кв|кв\.|квартира|УЛ|КВ|УЛИЦА|КВ\.|УЛ\.|КВАРТИРА)\s+([а-яА-Я]+)(?=\s+|$|[,])/;
    const regexEndWord = /(?:\s+|^)(?:ул|улица|ул\.|кв|кв\.|квартира|УЛ|КВ|УЛИЦА|КВ\.|УЛ\.|КВАРТИРА)(?=\s+|$|[,])/;
    return regexAvailability.test(value) || regexEndWord.test(value) ? {birthplaceWordBan: true} : null
  }

  static checkSmsConfirmationCode(control: UntypedFormGroup): {
    [key: string]: any;
  } {
    const code = control.value.replace(/\D/g, '');
    return code.length < 5 && code.length > 0
      ? {smsConfirmationLength: true}
      : null;
  }

  static checkSmsConfirmation(control: UntypedFormGroup): {
    [key: string]: any;
  } {
    const code = control.value.replace(/\D/g, '');
    return code.length < 4 && code.length > 0
      ? {smsConfirmationLength: true}
      : null;
  }

  static yandexrequired(control: UntypedFormGroup): { [key: string]: any } {
    return control.value ? null : {yandexrequired: true};
  }

  static yandexwalleterror(control: UntypedFormGroup): { [key: string]: any } {
    return control.value ? null : {yandexwalleterror: true};
  }

  static lengthbic(control: UntypedFormGroup): { [key: string]: any } {
    return control.value.replace(/_/g, '').length < 9
      ? {lengthbic: true}
      : null;
  }

  static lengthaccount(control: UntypedFormGroup): { [key: string]: any } {
    return control.value.replace(/_/g, '').length < 25
      ? {lengthaccount: true}
      : null;
  }

  static bankname(control: UntypedFormGroup): { [key: string]: any } {
    return null;
  }

  static bicformat(control: UntypedFormGroup): { [key: string]: any } {
    const length = control.value.replace(/_/g, '').length;
    if (length === 9) {
      return control.value.slice(0, 2) !== '04' ? {bicformat: true} : null;
    }
  }

  static settlementAccountformat(control: UntypedFormGroup): {
    [key: string]: any;
  } {
    return null;
  }

  static emailduplicate(control: UntypedFormGroup): { [key: string]: any } {
    return null;
  }

  static recoveryCodeLength(control: UntypedFormGroup): { [key: string]: any } {
    const value = control.value.replace(/_/g, '');
    if (value.length < 6) {
      return {recoveryCodeLength: true};
    }
  }

  static getValidationClassDate(formControl: FormControl) {
    if (!formControl)
      return 'valid'
    const {status, touched} = formControl;
    if (status === 'VALID' && !touched) {
      return 'valid';
    } else if (status === 'INVALID' && touched) {
      return 'ng-invalid ng-dirty';
    }
  }

  static getValidationClass(formControl: FormControl,
                            brand: string, disableRequiredIdentifier: boolean) {
    if (!formControl)
      return 'valid'
    const {status, touched} = formControl;
    if (status === 'VALID' && !touched && disableRequiredIdentifier) {
      if (brand === 'VIVUS') {
        return 'fa fa-check vivus-style';
      } else {
        return 'fa fa-check';
      }
    } else if (status === 'VALID' && touched && disableRequiredIdentifier) {
      if (brand === 'VIVUS') {
        return 'fa fa-check vivus-style';
      } else {
        return 'fa fa-check';
      }
    } else if (status === 'INVALID' && touched) {
      if (!disableRequiredIdentifier) {
        return 'ng-invalid ng-dirty'
      } else {
        return 'ng-invalid ng-dirty fa fa-asterisk';
      }
    } else if (status === 'INVALID' && !touched && disableRequiredIdentifier) {
      return 'fa fa-asterisk';
    }
  }

  static checkPassportDate = (issueDate: Date, birthday: Date) => {
    if (issueDate && birthday) {
      const id = moment(issueDate).set({
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
      });
      const bd = moment(birthday).set({
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
      });
      const fourteenYear = moment(bd).add(14, 'years');
      const twentyYear = moment(bd).add(20, 'years');
      const fortyYears = moment(bd).add(45, 'years');
      const years = moment().diff(bd, 'years');

      if (years >= 20 && years < 45) {
        if (!(id === twentyYear || (id.isAfter(twentyYear) && id.isBefore(fortyYears))))
          return {checkPassportDate: true};
      } else if (years >= 45) {
        if (!(id === fortyYears || id.isAfter(fortyYears)))
          return {checkPassportDate: true};
      } else if (id.isBefore(fourteenYear)) {
        return {checkPassportDate14: true};
      } else {
        return null
      }
    }
  };
}

